import React from "react";
import PharmacyOrderItem from "./PharmacyOrderItem/PharmacyOrderItem";

const PharmacyOrdersList = (props) => {
        const {orders} = props;

        const renderItem = (item,index) => {
            if (Array.isArray(item)) {
                console.log(item);
                return (
                    <div className={"batch-order-holder " + (index % 2 === 0 ? "batch-order-holder-gray" : "batch-order-holder-blue")} key={index}>
                        {
                            item.map((order, index) => {
                                return <PharmacyOrderItem key={index} order={order}/>
                            })
                        }
                    </div>
                )
            } else {
                return <PharmacyOrderItem key={index} order={item}/>
            }
        };
        return (
            <div className="lab-orders-list">
                {
                    orders.map((order, index) => {
                        return renderItem(order,index);
                    })
                }
            </div>
        )
    }
;

export default PharmacyOrdersList;